var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1l2.472 4.937L17 6.733l-4 3.841.944 5.426L9 13.437 4.056 16 5 10.574l-4-3.84 5.528-.797L9 1z",
    fill: "#73A3BB",
    stroke: "#73A3BB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMUwxMS40NzIgNS45MzY5MUwxNyA2LjczMzQ0TDEzIDEwLjU3NDFMMTMuOTQ0IDE2TDkgMTMuNDM2OUw0LjA1NiAxNkw1IDEwLjU3NDFMMSA2LjczMzQ0TDYuNTI4IDUuOTM2OTFMOSAxWiIgZmlsbD0iIzczQTNCQiIgc3Ryb2tlPSIjNzNBM0JCIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgStar as ReactComponent };